import React from 'react';
import PropTypes from 'prop-types';

import LinkCustom from 'gatsby-core-theme/src/hooks/link';
import useTranslate from '~hooks/useTranslate/useTranslate';

const ReviewLink = ({
  template,
  pageName,
  operatorName,
  reviewPath,
  className,
  nofollow = false,
  isComparisonTable = false,
}) => {
  let isBonusTemplate = false;

  if (['free_bonuses', 'bonus_pages', 'casino_bonus'].includes(template)) {
    isBonusTemplate = true;
  }

  return (
    <LinkCustom className={className || ''} nofollow={nofollow} to={reviewPath}>{`${
      isBonusTemplate
        ? useTranslate('bonus', '[operator_name] Bonus').replace(
            '[operator_name]',
            pageName || operatorName
          )
        : useTranslate(
            isComparisonTable ? 'read_review_comparison' : 'read_review',
            (pageName && '[operator_name]') || (operatorName && '[operator_name] Review')
          ).replace('[operator_name]', pageName || operatorName)
    }`}</LinkCustom>
  );
};

ReviewLink.propTypes = {
  template: PropTypes.string,
  pageName: PropTypes.string,
  nofollow: PropTypes.bool,
  operatorName: PropTypes.string,
  reviewPath: PropTypes.string,
  className: PropTypes.string,
  isComparisonTable: PropTypes.bool,
};

export default ReviewLink;
